export const DDDNestEventsPost = () => {
  return (
    <article className='blog-post'>
      <h1>DDD with NestJS: Aggregates &amp; Domain Events in 40 Lines</h1>

      <h2>The Problem</h2>
      <p>
        A fintech audit demanded a transparent event trail. Legacy code hid
        side‑effects inside repositories, making it impossible to prove
        invariants. By switching to the <code>@nestjs/cqrs</code> module we
        pushed every domain mutation onto an in‑memory bus, with <em>zero</em>{' '}
        runtime overhead.
      </p>

      <h2>Event &amp; Aggregate</h2>
      <pre>
        {`// user-created.event.ts
        export class UserCreatedEvent {
          constructor(public readonly userId: string, public readonly email: string) {}
        }

        // user.aggregate.ts
        import { AggregateRoot } from '@nestjs/cqrs';

        export class User extends AggregateRoot {
          constructor(private readonly props: { id: string; email: string }) {
            super();
            // business rules here …
            this.apply(new UserCreatedEvent(props.id, props.email));
          }
        }
        `}
      </pre>

      <h2>Plumbing the Bus</h2>
      <p>
        Register an <code>UserCreatedHandler</code> that sends welcome emails,
        logs metrics to OpenTelemetry and persists events to Postgres via the
        Outbox pattern. Your aggregate stays pure; handlers can fail and retry
        without polluting domain logic.
      </p>

      <h2>Production Win</h2>
      <ul>
        <li>
          Onboarding juniors became a breeze—there is exactly{' '}
          <strong>one</strong> way data can flow.
        </li>
        <li>Audit trail feeds Kibana dashboards in real time.</li>
      </ul>

      <hr />
      <p className='cta'>
        Enjoyed this? Let’s chat on{' '}
        <a
          className='link'
          href='https://www.linkedin.com/in/juan-marcelo-rodriguez-dev/'
          target='_blank'
          rel='noreferrer'
        >
          LinkedIn
        </a>
        .
      </p>
    </article>
  );
};
